import React from 'react';
import { translate, hasTranslation, I18n } from '@fiverr-private/i18n-react';

export const appTranslate = (key: string, options?: any) => translate(`vibe_coding_perseus.${key}`, options);

export const hasAppTranslation = (key: string) => hasTranslation(`vibe_coding_perseus.${key}`);

export const AppI18n = ({ k, ...props }: { k: string; [key: string]: any }) => {
    const fullKey = `vibe_coding_perseus.${k}`;
    return <I18n k={fullKey} {...props} />;
};
